import { PREVIEW_SHOWN } from "../products/rows.ts";
import type { RowPreview } from "../products/rows.ts";
import { GUIDE_PATH } from "../routes.ts";

export const GUIDE_SECTIONS = [
  { id: "start", pages: ["get-started", "own-bot", "commands"] },
  { id: "analytics", pages: ["analytics", "insights", "annotations", "charts", "metrics"] },
  {
    id: "rewards",
    pages: [
      "leveling",
      "xp-and-levels",
      "rewards",
      "supporter-perks",
      "level-ups-and-cards",
      "requests",
      "import",
      "giveaways",
    ],
  },
  { id: "workspace", pages: ["team-access", "billing", "privacy"] },
] as const satisfies readonly { readonly id: string; readonly pages: readonly string[] }[];

export type GuideSectionId = (typeof GUIDE_SECTIONS)[number]["id"];

export type GuideSlug = (typeof GUIDE_SECTIONS)[number]["pages"][number];

export const GUIDE_SLUGS: readonly GuideSlug[] = GUIDE_SECTIONS.flatMap((section) => section.pages);

export const isGuideSlug = (value: string): value is GuideSlug =>
  (GUIDE_SLUGS as readonly string[]).includes(value);

export const guidePath = (slug: GuideSlug): string => `${GUIDE_PATH}/${slug}`;

export const guideMarkdownPath = (slug: GuideSlug): string => `${guidePath(slug)}.md`;

export type EmbedName = RowPreview;

export const isEmbedName = (value: string): value is EmbedName =>
  Object.hasOwn(PREVIEW_SHOWN, value);
